import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  variant?: 'default' | 'compact';
}

export default function ComicCard({ comic, variant = 'default' }: ComicCardProps) {
  const firstChapter = comic.chapters[0];

  if (variant === 'compact') {
    return (
      <Link
        to={firstChapter ? `/article/${comic.id}/${firstChapter.id}` : '#'}
        className="group block cursor-pointer"
      >
        <div className="flex gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors">
          <div className="w-16 h-[84px] flex-shrink-0 rounded-md overflow-hidden">
            <img
              src={comic.coverImage}
              alt={`${comic.title} 漫画封面`}
              title={`${comic.title} - 89890漫画网免费阅读`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
              {comic.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
            <div className="flex items-center gap-3 mt-1.5">
              <span className="text-xs text-foreground-500">
                <i className="ri-eye-line mr-0.5"></i>
                {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
              </span>
              <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                comic.status === '连载中'
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}>
                {comic.status}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={firstChapter ? `/article/${comic.id}/${firstChapter.id}` : '#'}
      className="group block cursor-pointer"
    >
      <div className="rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={comic.coverImage}
            alt={`${comic.title} 漫画封面`}
            title={`${comic.title} - 89890漫画网免费阅读`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-2 right-2">
            <span className={`text-xs px-2 py-1 rounded-full ${
              comic.status === '连载中'
                ? 'bg-accent-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}>
              {comic.status}
            </span>
          </div>
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
            <div className="flex items-center gap-2 text-background-50 text-xs">
              <span className="flex items-center gap-0.5">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                {comic.rating}
              </span>
              <span>·</span>
              <span className="flex items-center gap-0.5">
                <i className="ri-eye-line"></i>
                {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
              </span>
            </div>
          </div>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
          <div className="flex items-center gap-2 mt-2 flex-wrap">
            {comic.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="text-xs px-2 py-0.5 bg-background-100 text-foreground-600 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}